import React, { useState } from 'react'
import { Popover, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { PopoverContent, settingsPopoverStyles, PopoverWrapper, FlippedErrorOutline } from './styles'

const SettingsPopover = ({ classes, content, children }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  return (
    <PopoverWrapper>
      <Typography
        aria-owns={anchorEl ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        onMouseEnter={handlePopoverOpen}
        open={!!anchorEl}
      >
        <FlippedErrorOutline />
      </Typography>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <PopoverContent
          onMouseLeave={handlePopoverClose}
        >
          {children || content}
        </PopoverContent>
      </Popover>
    </PopoverWrapper>
  )
}

export default withStyles(settingsPopoverStyles)(SettingsPopover)
